module.exports = __webpack_public_path__ + "static/photobooth-fonts-scripts.f616924b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photobooth-fonts-scripts.jpg
// module id = 815
// module chunks = 73896326755509